import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const Container = styled(Flex)`
    width: 100%;
    position: relative;
    cursor: pointer;
`;

export const InfoSectionLeft = styled(Stack)`
    flex: 1;
    gap: 8px;
    align-items: flex-start;
    min-width: 0;
`;

export const RightAsideLoaderWrapper = styled(Flex)`
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
`;

export const ShareOfVoice = styled.span`
    ${setFontVariant("h4", carbon[500])};
`;

export const ChangeWrapper = styled.span`
    .change-indication__value {
        font-size: 14px;
    }

    @media (max-width: 1350px) {
        .change-indication__value {
            font-size: 12px;
        }
    }
`;

export const Message = styled.div`
    ${setFontVariant("listItem3", carbon[300])};
`;
